import { createReducer, on } from '@ngrx/store';
import { ProfileStateInterface } from '../types';
import * as profileActions from './actions';

export const initialState: ProfileStateInterface = {
  isLoading: false,
  profileData: null,
  error: '',
};

export const ProfileReducers = createReducer(
  initialState,
  on(profileActions.getProfileData, (state) => ({ ...state, isLoading: true })),
  on(profileActions.getProfileDataSuccess, (state, action) => ({
    isLoading: false,
    profileData: {
      email: action.email,
      user_information: action.user_information,
      documents: action.documents,
    },
    error: '',
  })),
  on(profileActions.getProfileDataFromHomeSuccess, (state, action) => ({
    isLoading: false,
    profileData: {
      email: action.email,
      user_information: action.user_information,
      documents: action.documents,
    },
    error: '',
  })),
  on(profileActions.getProfileDataSuccessAlreadyLoaded, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(profileActions.updateProfileDataUserInformation, (state, action) => ({
    ...state,
    profileData: {
      ...state.profileData,
      user_information: {
        ...state.profileData?.user_information,
        id: action.user_information?.id,
        firstname: action.user_information?.firstname,
        lastname: action.user_information?.lastname,
        gender: action.user_information?.gender,
        birthday: action.user_information?.birthday,
        street: action.user_information?.street,
        houseNumber: action.user_information?.houseNumber,
        zipCode: action.user_information?.zipCode,
        cityCountry: action.user_information?.cityCountry,
        acquiredLanguage: action.user_information?.acquiredLanguage,
        acquiredLanguageLevel: action.user_information?.acquiredLanguageLevel,
      },
    },
  })),
  on(profileActions.updateProfileDocuments, (state, action) => ({
    ...state,
    profileData: {
      email: state.profileData?.email,
      user_information: {
        id: state.profileData?.user_information?.id,
        firstname: state.profileData?.user_information?.firstname,
        lastname: state.profileData?.user_information?.lastname,
        gender: state.profileData?.user_information?.gender,
        birthday: state.profileData?.user_information?.birthday,
        street: state.profileData?.user_information?.street,
        houseNumber: state.profileData?.user_information?.houseNumber,
        zipCode: state.profileData?.user_information?.zipCode,
        cityCountry: state.profileData?.user_information?.cityCountry,
        experiences: state.profileData?.user_information?.experiences,
        hobbies: state.profileData?.user_information?.hobbies,
      },
      documents: action.documents,
    },
  })),
  on(profileActions.updateProfileDataExperiences, (state, action) => ({
    ...state,
    profileData: {
      email: state.profileData?.email,
      user_information: {
        firstname: state.profileData?.user_information?.firstname,
        lastname: state.profileData?.user_information?.lastname,
        gender: state.profileData?.user_information?.gender,
        birthday: state.profileData?.user_information?.birthday,
        street: state.profileData?.user_information?.street,
        houseNumber: state.profileData?.user_information?.houseNumber,
        zipCode: state.profileData?.user_information?.zipCode,
        cityCountry: state.profileData?.user_information?.cityCountry,        experiences: action.user_information?.experiences,
        hobbies: state.profileData?.user_information?.hobbies,
      },
      documents: state.profileData?.documents,
    },
  })),
  on(profileActions.updateProfileDataHobbies, (state, action) => ({
    ...state,
    profileData: {
      email: state.profileData?.email,
      user_information: {
        firstname: state.profileData?.user_information?.firstname,
        lastname: state.profileData?.user_information?.lastname,
        gender: state.profileData?.user_information?.gender,
        birthday: state.profileData?.user_information?.birthday,
        street: state.profileData?.user_information?.street,
        houseNumber: state.profileData?.user_information?.houseNumber,
        zipCode: state.profileData?.user_information?.zipCode,
        cityCountry: state.profileData?.user_information?.cityCountry,        experiences: state.profileData?.user_information?.experiences,
        hobbies: action.user_information?.hobbies,
      },
      documents: state.profileData?.documents,
    },
  })),
  on(profileActions.getProfileDataFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),

  on(profileActions.updateDocuments, (state, action) => ({
    ...state,
    profileData: {
      email: state.profileData?.email,
      user_information: {
        firstname: state.profileData?.user_information?.firstname,
        lastname: state.profileData?.user_information?.lastname,
        gender: state.profileData?.user_information?.gender,
        birthday: state.profileData?.user_information?.birthday,
        street: state.profileData?.user_information?.street,
        houseNumber: state.profileData?.user_information?.houseNumber,
        zipCode: state.profileData?.user_information?.zipCode,
        cityCountry: state.profileData?.user_information?.cityCountry,        experiences: state.profileData?.user_information?.experiences,
        hobbies: state.profileData?.user_information?.hobbies,
      },
      documents: [...(state.profileData?.documents ?? []), action.document],
    },
  })),

  on(profileActions.removeDocument, (state, action) => ({
    ...state,
    profileData: {
      email: state.profileData?.email,
      user_information: {
        firstname: state.profileData?.user_information?.firstname,
        lastname: state.profileData?.user_information?.lastname,
        gender: state.profileData?.user_information?.gender,
        birthday: state.profileData?.user_information?.birthday,
        street: state.profileData?.user_information?.street,
        houseNumber: state.profileData?.user_information?.houseNumber,
        zipCode: state.profileData?.user_information?.zipCode,
        cityCountry: state.profileData?.user_information?.cityCountry,        experiences: state.profileData?.user_information?.experiences,
        hobbies: state.profileData?.user_information?.hobbies,
      },
      documents: state.profileData?.documents?.filter(userDocument => userDocument.type != action.documentType),
    },
  })),

  on(profileActions.resetProfileData, () => ({
    ...initialState
  })),
);
